<template>

	<div class="top-bar--admin">

        <div class="top-bar__wrap--admin">

            <h3>Selskaber</h3>

			<nav class="settings pull-right" v-if="user">

				<ws-dropdown>

					<template slot="thumb">Hej, {{user.name | firstname}} <i class="fas fa-angle-down"></i></template>
					<template slot="content">
                		<ul>
							<!--<li><router-link :to="{ name: 'settings' }"><i class="im im-gear"></i>Account settings</router-link></li>-->
                            <li><a href="/admin"><i class="fas fa-exchange-alt"></i>Skift til vælgeside</a></li>
							<li><a href="#" @click.prevent="logOut"><i class="fas fa-power-off"></i>Log af dashboard</a></li>
                		</ul>
                	</template>

				</ws-dropdown>

				<div class="user-icon">

					<i class="im im-user-circle"></i>

				</div>

			</nav>

        </div>

    </div>

</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        name: "topmenu",
        data(){
            return {
                showNav: false,
            }
        },
        computed: mapGetters({
            user:'user',
        }),
        methods: {
            logOut() {
                axios.post('/logout').then(() => {
                    location.reload();
                }).catch(() => {
                    location.reload();
                });
            },
            toggleNav(){
                this.showNav = !this.showNav;
            },
            hideNav(){
                this.showNav = false;
            },
        },
        filters: {
            firstname: function (value) {
                if (!value) return '';
                value = value.toString();
                return value.split(" ")[0];
            }
        }
    }
</script>
